import { useEffect, useMemo } from "react";
import { useExpressionEvaluatorContext } from "../../../ExpressionsModule/Hooks/useExpressionEvaluatorContext";
import { ObjectVariableScope } from "../../../ExpressionsModule/Runtime/VariableScopes/ObjectVariableScope";
import { ViewModel } from "../../Models/ViewModel";
import { ComponentService } from "../../Services/ComponentService";

export default function useViewExpressionEvaluatorContext(component: ViewModel, input?: Record<string, any>) {
  const context = useExpressionEvaluatorContext();

  const viewContext = useMemo(() => {
    const viewContext = context.CreateChild();
    const viewKey = "$view";
    viewContext.VariableScope.set(viewKey, new ObjectVariableScope({}, viewContext.VariableScope, viewKey));
    console.log("[useViewExpressionEvaluatorContext] Created viewContext:", viewContext);

    const componentService = new ComponentService();
    componentService.setViewComponentId(component.Id);
    viewContext.SetProperty(ComponentService.KEY, componentService);

    return viewContext;
  }, [context]);

  useEffect(() => {
    viewContext.VariableScope.set("$input", input);
    console.log("[useViewExpressionEvaluatorContext] Set $input:", input);
  }, [viewContext, input]);

  return viewContext;
}
